<template>
		<div class="grid dashboardGrid">
	<div class="col-12 xl:col-6">
		<div class="card">
			<h5>Rendez-vous  du jour</h5>
      <h6 v-if="upcomingAppointments.length == 0">Aucun rendez-vous aujourd'hui</h6>
        <GridLoader v-if="upcomingLoading" class="loader"></GridLoader>
        <TimeLine v-if="upcomingAppointments.length > 0" :value="upcomingAppointments">
                <template #opposite="slotProps">
                   <i class="pi pi-clock timelineClock"></i><a :class="{past : slotProps.item.past}" class="timelineHour">{{getNiceTime(slotProps.item.start)}}</a>
                </template>
                <template #content="slotProps">
                    <a :class="{past : slotProps.item.past}" class="timelineClient" @click="goToClient(slotProps.item.clientid)">{{slotProps.item.name}}</a>
                </template>
          </TimeLine>
		</div>
		
	</div>

	<div class="col-12 xl:col-6">
	<div class="card">
			<h5>Métriques rapides</h5>
      <GridLoader v-if="metricsLoading" class="loader"></GridLoader>
      <div v-if="!metricsLoading" class="quickMetrics">
        <div class="metricRow">
          <span class="metricLabel">RDV restants cette semaine (jusqu'à samedi)</span>
          <span class="metricValue">{{ appointmentsLeftThisWeek }}</span>
        </div>
        <div class="metricRow metricRowWithList">
          <div class="metricTopLine">
            <span class="metricLabel">Nouveaux RDV (7 derniers jours)</span>
            <span class="metricValue">{{ newAppointmentsLast7Days }}</span>
          </div>
          <button type="button" class="toggleNewAppointmentsBtn" @click="showRecentAppointments = !showRecentAppointments">
            {{ showRecentAppointments ? 'Masquer la liste' : 'Afficher la liste' }}
          </button>
          <div v-if="showRecentAppointments" class="newAppointmentsList">
            <div v-if="recentAppointments.length === 0" class="newAppointmentsEmpty">Aucun nouveau RDV</div>
            <button
              v-for="(app, idx) in recentAppointments"
              :key="`${app.clientid || app.id || idx}-${app.start || idx}`"
              class="newAppointmentItem"
              type="button"
              @click="goToClient(app.clientid)"
            >
              <span class="newAppointmentName">{{ app.name || 'Client' }}</span>
              <span class="newAppointmentDate">{{ formatDateTime(app.start) }}</span>
            </button>
          </div>
        </div>
      </div>
	</div>
		
</div>
</div>

	<div class="grid dashboardGrid">
		<div class="col-12 lg:col-12 xl:col-12">
      <div class="card">
			<h5>Rendez-vous non-clôturés</h5>
      <AppointmentListView :appointments="openAppointments" @app-updated="loadOpenAppointments()"/>
	</div>
		</div>
</div>

</template>

<style scoped>
.past {
  color:grey !important;
}

.timelineClock,
.timelineHour {
  font-size: 1.1rem;
}

.timelineClock {
  margin: 0 0.3rem;
}

.timelineClient {
  cursor: pointer;
  font-weight: 600;
}

.quickMetrics {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.metricRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.8rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

.metricLabel {
  color: #374151;
  min-width: 0;
  flex: 1 1 180px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.metricValue {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  flex: 0 0 auto;
}

.metricRowWithList {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 0.45rem;
}

.metricTopLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;
}

.newAppointmentsList {
  margin-top: 0.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.newAppointmentsEmpty {
  color: #6b7280;
  font-size: 0.9rem;
}

.toggleNewAppointmentsBtn {
  border: 1px solid #dbe5f3;
  background: #ffffff;
  color: #32486f;
  border-radius: 8px;
  padding: 0.45rem 0.6rem;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
}

.newAppointmentItem {
  border: 1px solid #dbe5f3;
  background: #f8fbff;
  border-radius: 8px;
  padding: 0.5rem 0.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.6rem;
  text-align: left;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
}

.newAppointmentName {
  font-weight: 600;
  color: #1f2f4e;
  min-width: 0;
  overflow-wrap: anywhere;
}

.newAppointmentDate {
  color: #5f6f8f;
  font-size: 0.88rem;
  white-space: nowrap;
  flex: 0 0 auto;
}

@media (max-width: 991px) {
  .dashboardGrid {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
  }

  .dashboardGrid > [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }

  .card {
    padding: 0.8rem 0.8rem 0.85rem;
    margin-bottom: 0.75rem;
  }

  h5 {
    margin: 0 0 0.65rem 0;
  }

  h6 {
    margin: 0.25rem 0 0.35rem 0;
  }

  .quickMetrics {
    gap: 0.5rem;
  }

  .metricRow {
    padding: 0.55rem 0.6rem;
  }

  .metricTopLine {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.15rem;
  }

  .metricTopLine .metricLabel {
    flex: 0 1 auto;
  }

  .metricTopLine .metricValue {
    align-self: flex-start;
  }

  .newAppointmentsList {
    gap: 0.3rem;
  }

  .newAppointmentItem {
    padding: 0.4rem 0.5rem;
  }
}
</style>



<script setup>

import { ref, onMounted } from 'vue';
import axios from 'axios'
import { useRouter } from 'vue-router';
import { authHeader } from '../helpers/authHeader.js';
import { userService } from '../services/userService.js';
import { getNiceTime } from  '../dateUtils.js';



import { useMainStore } from '../store'
import AppointmentListView from './AppointmentListView.vue';




const upcomingLoading = ref(false);
const openAppointmentsLoading = ref(false);
const metricsLoading = ref(false);
const appointmentsLeftThisWeek = ref(0);
const newAppointmentsLast7Days = ref(0);
const recentAppointments = ref([]);
const showRecentAppointments = ref(false);




const store = useMainStore();

const router = useRouter();




function goToClient(id) {
  if (!id) {
    return;
  }
  store.$patch((state) => {
              state.currentClientFile = id
          });

          router.push('/clients');

}






 onMounted(() => {
    loadUpcoming();
    loadOpenAppointments();
    loadQuickMetrics();
});






const upcomingAppointments = ref([]);
const openAppointments = ref([]);

function loadOpenAppointments()
{
  openAppointmentsLoading.value = true;
    openAppointments.value = [];

      var options = {
        "headers" :  authHeader()
      };

      axios
      .get(`${process.env.VUE_APP_API_URL}/Appointments/getOpen`, options)
      .then(response => {
          openAppointments.value = response.data;
          openAppointmentsLoading.value = false;
      });
}

function loadQuickMetrics() {
  metricsLoading.value = true;
  recentAppointments.value = [];

  const options = {
    "headers": authHeader()
  };

  const now = new Date();
  const endOfSaturday = new Date(now);
  const daysUntilSaturday = (6 - endOfSaturday.getDay() + 7) % 7;
  endOfSaturday.setDate(endOfSaturday.getDate() + daysUntilSaturday);
  endOfSaturday.setHours(23, 59, 59, 999);

  const sevenDaysAgo = new Date(now);
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  const fromWeek = encodeURIComponent(now.toISOString());
  const toWeek = encodeURIComponent(endOfSaturday.toISOString());
  const fromLast7 = encodeURIComponent(sevenDaysAgo.toISOString());
  const toLast7 = encodeURIComponent(now.toISOString());

  Promise.all([
    axios.get(`${process.env.VUE_APP_API_URL}/Appointments/getUpcoming?from=${fromWeek}&to=${toWeek}`, options),
    axios.get(`${process.env.VUE_APP_API_URL}/Appointments/getCreatedCount?from=${fromLast7}&to=${toLast7}`, options),
    axios.get(`${process.env.VUE_APP_API_URL}/Appointments/getCreated?from=${fromLast7}&to=${toLast7}`, options)
  ])
    .then(([leftThisWeekResponse, last7DaysResponse, recentAppointmentsResponse]) => {
      appointmentsLeftThisWeek.value = (leftThisWeekResponse.data || []).length;
      newAppointmentsLast7Days.value = Number(last7DaysResponse.data || 0);
      recentAppointments.value = (recentAppointmentsResponse.data || [])
        .filter(item => item && item.start)
        .sort((a, b) => new Date(b.start) - new Date(a.start));
      metricsLoading.value = false;
    })
    .catch((reason) => {
      metricsLoading.value = false;
      console.log(reason);
    });
}

function formatDateTime(value) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return String(value);
  }
  return date.toLocaleString('fr-CH', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
}


function loadUpcoming(){
  upcomingLoading.value = true;
  upcomingAppointments.value = [];


  let today = new Date();
  let tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  var offset = today.getTimezoneOffset()
  today = new Date(today.getTime() - (offset*60*1000))
  today = today.toISOString().split('T')[0];

  offset = tomorrow.getTimezoneOffset()
  tomorrow = new Date(tomorrow.getTime() - (offset*60*1000))
  tomorrow = tomorrow.toISOString().split('T')[0];

  
  console.log(today);
  console.log(tomorrow);

   var options = {
        "headers" :  authHeader()
      };

         axios
            .get(`${process.env.VUE_APP_API_URL}/Appointments/GetUpcoming?from=${today}&to=${tomorrow}`, options)
            .then(response => {
              upcomingAppointments.value = response.data;
              classifyUpcomingAppointments();
              upcomingLoading.value = false;
      }).catch(reason => {
          if(reason.message.includes("401"))
          {
            userService.logout();
            router.push({path: '/login'})

          }
          else
          {
            alert("erreur : " + reason.message);
          }
      });
}

function classifyUpcomingAppointments()
{
  upcomingAppointments.value.forEach(app => {
    
    const date = new Date(app.start)
    if(date < new Date())
    {
        app.past = true;
    }
    else 
    {
      app.past = false;
    }


  })
}


</script>
